import { Compass, BadgePercent, Sparkles, FileCheck2 } from "lucide-react";
import { Stagger, Item, SectionHead } from "./shared";
import { useI18n } from "../i18n/LanguageContext";

const ICONS = [Compass, BadgePercent, Sparkles, FileCheck2];

export const WhyUs = () => {
  const { t, c } = useI18n();
  return (
    <section id="why" className="bg-white py-20 sm:py-28" data-testid="why-section">
      <div className="container-x">
        <SectionHead eyebrow={t.why.eyebrow} title={t.why.title} sub={t.why.sub} />
        <Stagger className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {c.MANIFESTO.map((m, i) => {
            const Icon = ICONS[i];
            return (
              <Item key={m.no}>
                <div className="group h-full rounded-3xl border border-navy/5 bg-cream p-7 transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-soft" data-testid={`why-card-${m.no}`}>
                  <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-navy text-gold-300 transition-colors duration-500 group-hover:bg-gold group-hover:text-white">
                    <Icon size={24} />
                  </span>
                  <h3 className="mt-6 font-display text-xl font-semibold tracking-tight text-navy">{m.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted">{m.body}</p>
                </div>
              </Item>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
};
